export default {
  label: {
    updateBy: 'Công cụ sửa đổi',
    updateDate: 'thời gian sửa đổi',
    createAcct: 'người sáng lập',
    createTime: 'Thời gian sáng tạo',
    merchantNo: 'số doanh nghiệp',
    updateAcct: 'người cập nhật',
    updateTime: 'Cập nhật thời gian',
    walletAmount: 'Số tiền trên ví',
    walletType: 'Loại ví',
    momo: 'Momo',
    zalo: 'Zalo',
    vtp: 'Viettel pay',
    vtpFix: 'Viettel pay fix',
    bankOnline: 'Bank online',
    transfer: 'Bank transfer',
    bankQr: 'Bank QR',
    all: 'All',
    card: 'Card',
    payout: 'Payout',
    allMerchantBalance: 'Tổng số dư của người bán',
    todayPayoutAmount: 'Số tiền rút hôm nay',
    todayBalanceAmount: 'Tổng số dư ví',
    todayTradeAmount: 'Số tiền giao dịch hôm nay',
    yesterdayTradeAmount: 'Số tiền giao dịch ngày hôm qua'
  },
  rules: {
    walletType: 'Loại ví không được để trống!'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/merchantBalance.js